import { z } from 'zod';
import { refersTo } from '../common/refers-to';

// German PLZ: exactly five digits. The one validation boundary for the
// coverage endpoints — the backend receives an already-clean 5-digit value.
export const PostalCodeSchema = z.string().regex(/^\d{5}$/);

export type PostalCode = z.infer<typeof PostalCodeSchema>;

// Org-addressed (top-level `/v1/organizations/:organizationId/postal-codes`):
// the workspace is derived from the organisation by the gate, so the path
// carries only the organisation id.
export const ListCoveragePostalCodesPathParamsSchema = z.object({
  organizationId: z.uuid(),
});

export const ListCoveragePostalCodesResponseSchema = z.object({
  postalCodes: z.array(z.string()),
});

export type ListCoveragePostalCodesResponse = z.infer<typeof ListCoveragePostalCodesResponseSchema>;

export const AssignCoveragePostalCodesPathParamsSchema = z.object({
  organizationId: z.uuid(),
});

export const AssignCoveragePostalCodesBodySchema = z.object({
  postalCodes: z.array(PostalCodeSchema).min(1),
});

export type AssignCoveragePostalCodesBody = z.infer<typeof AssignCoveragePostalCodesBodySchema>;

// One blocked PLZ and the Standort that already owns it in the workspace. The
// owner name is resolved server-side so the client can render the conflict line
// without a second lookup.
export const CoveragePostalCodeConflictSchema = z.object({
  postalCode: z.string(),
  organizationId: refersTo('organization', z.uuid()),
  organizationName: z.string(),
});

export type CoveragePostalCodeConflict = z.infer<typeof CoveragePostalCodeConflictSchema>;

export const AssignCoveragePostalCodesResponseSchema = z.object({
  assigned: z.array(z.string()),
  alreadyPresent: z.array(z.string()),
  conflicts: z.array(CoveragePostalCodeConflictSchema),
});

export type AssignCoveragePostalCodesResponse = z.infer<typeof AssignCoveragePostalCodesResponseSchema>;

export const RemoveCoveragePostalCodePathParamsSchema = z.object({
  organizationId: z.uuid(),
  postalCode: PostalCodeSchema,
});

export const RemoveCoveragePostalCodeResponseSchema = z.object({});

export type RemoveCoveragePostalCodeResponse = z.infer<typeof RemoveCoveragePostalCodeResponseSchema>;
